import { Sparkles, Download } from "lucide-react";

/**
 * Animated demo card shown in the Home page hero.
 * Self-contained - no props needed.
 */
export function DemoCard() {
  return (
    <div className="relative flex justify-center">
      <div className="bg-card border border-border rounded-2xl p-6 w-full max-w-[400px] shadow-[0_8px_40px_rgba(0,0,0,0.1)] animate-card-rise">
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="font-display text-[1.125rem] text-foreground">Mary R.</div>
            <div className="text-xs text-muted-foreground mt-[0.15rem]">Grade 3 · Mathematics · Term 1</div>
          </div>
          <span className="inline-flex items-center gap-1 text-[0.625rem] font-bold tracking-[0.06em] uppercase px-2 py-[0.2rem] bg-brand-700/[0.12] text-brand-700 dark:bg-brand-400/20 dark:text-brand-300 rounded-full">
            <Sparkles size={11} />
            AI
          </span>
        </div>
        <div className="flex flex-wrap gap-[0.4rem] mb-4">
          <span className="text-xs px-[0.6rem] py-[0.2rem] bg-muted rounded-[6px] text-muted-foreground">Overall: B+</span>
          <span className="text-xs px-[0.6rem] py-[0.2rem] bg-muted rounded-[6px] text-muted-foreground">Absences: 2</span>
          <span className="text-xs px-[0.6rem] py-[0.2rem] bg-muted rounded-[6px] text-muted-foreground">Participation: ✓</span>
        </div>
        <div className="bg-accent rounded-[10px] p-4 mb-4 animate-comment-reveal">
          <div className="text-[0.6875rem] font-semibold tracking-[0.06em] uppercase text-brand-700 dark:text-brand-300 mb-2">Generated comment</div>
          <p className="text-sm leading-relaxed text-foreground m-0">
            &ldquo;Mary demonstrates a strong understanding of algebraic rules
            and consistently applies mathematical strategies when
            problem-solving. She articulates her reasoning clearly and
            contributes thoughtfully during class discussions. Mary would
            benefit from continued practice with multi-step word
            problems.&rdquo;
          </p>
        </div>
        <div className="flex items-center justify-between">
          <span className="inline-flex items-center gap-[0.3rem] text-[0.8125rem] font-medium text-brand-700 dark:text-brand-300 cursor-pointer">
            <Download size={13} /> Export PDF
          </span>
          <span className="text-xs text-muted-foreground">247 characters</span>
        </div>
      </div>
      <div className="absolute inset-[-20px] bg-[radial-gradient(ellipse_at_60%_40%,hsl(152_40%_60%/0.15),transparent_70%)] pointer-events-none -z-[1]" />
    </div>
  );
}
